module.exports = __webpack_public_path__ + "static/media/move.4112f37f.png";